import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { MatCardModule } from "@angular/material/card";

@Component({
  selector: "app-form-error-from-server-bottom-sheet",
  templateUrl: "./form-error-from-server-bottom-sheet.component.html",
  styleUrls: ["./form-error-from-server-bottom-sheet.component.css"],
  imports: [CommonModule, MatCardModule],
})
export class FormErrorFromServerBottomSheetComponent implements OnInit {
  pErrorResponse: any;

  baseError: any;

  errorMessage: string;

  errorMessageList: string[];

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
    this.baseError = data.error;
    if (this.baseError["error"]) {
      this.errorMessage = this.baseError["error"];
    } else if (this.baseError["errors"]) {
      this.errorMessageList = [];
      for (let key in this.baseError["errors"]) {
        this.errorMessageList.push(this.baseError["errors"][key]);
      }
      console.log(this.errorMessageList);
    }
  }

  ngOnInit() {}
}
